<div class="entity-menu-dialog scroll-container">

  @if (data.entityIndexKey && data.entity) {
  <ghs-entity-index-key [entity]="data.entity" [show]="true"></ghs-entity-index-key>
  }

  <div class="name">
    @if (data.entity && gameManager.isCharacter(data.figure) && gameManager.isCharacter(data.entity)) {
    <span class="spacer"></span>
    <img tabclick (click)="toggleCharacterMarker()" class="icon character-icon"
      [src]="gameManager.toCharacter(data.figure).iconUrl" />
    <span class="character-title"
      [ngClass]="{'absent' : gameManager.toCharacter(data.figure).absent}">{{gameManager.characterManager.characterName(gameManager.toCharacter(data.figure),true)}}</span>
    <span class="spacer"></span>
    <img class="absent"
      [src]="'./assets/images/status/' + (gameManager.toCharacter(data.figure).absent ? 'absent': 'present') + '.svg'"
      [ghs-label]="(gameManager.toCharacter(data.figure).absent ? 'character.present' : 'character.absent')"
      [ghs-label-attribute]="'title'" tabclick (click)="toggleCharacterAbsent()">
    }
    @if (gameManager.isObjectiveContainer(data.figure)) {
    <img class="icon"
      [src]="'./assets/images/objective/' + (gameManager.toObjectiveContainer(data.figure).escort ? 'escort' : 'objective') + '.svg'" />
    @if (gameManager.toObjectiveContainer(data.figure).title) {
    <span>{{
      gameManager.toObjectiveContainer(data.figure).title}}</span>
    }
    @if (!gameManager.toObjectiveContainer(data.figure).title && gameManager.toObjectiveContainer(data.figure).name) {
    <span [ghs-label]="'data.objective.' + gameManager.toObjectiveContainer(data.figure).name"></span>
    }
    @if (!gameManager.toObjectiveContainer(data.figure).title && !gameManager.toObjectiveContainer(data.figure).name) {
    <span [ghs-label]="gameManager.toObjectiveContainer(data.figure).escort ? 'escort' : 'objective'"></span>
    }
    @if (gameManager.toObjectiveContainer(data.figure).title) {
    <span>
      &nbsp;(
      <span [ghs-label]="gameManager.toObjectiveContainer(data.figure).escort ? 'escort' : 'objective'"></span>
      )
    </span>
    }
    }
    @if (gameManager.isMonster(data.figure)) {
    <div class="name" tabclick (click)="changeMonsterEntity()"
      [ngClass]="{'change-entity': gameManager.monsterManager.monsterStandeeMax(gameManager.toMonster(data.figure)) > 1 || data.entity && gameManager.isMonsterEntity(data.entity) && gameManager.toMonsterEntity(data.entity).type != MonsterType.boss}">
      @if (!gameManager.toMonster(data.figure).noThumbnail && settingsManager.settings.artwork) {
      <img class="standee" [src]="gameManager.monsterManager.monsterThumbnail(gameManager.toMonster(data.figure))" />
      }
      <span [ghs-label]="'data.monster.' + data.figure.name"></span>&nbsp;
      @if (gameManager.toMonster(data.figure).isAlly) {
      <span class="ally"><span [ghs-label]="'game.ally'"></span>&nbsp;</span>
      }
      @if (gameManager.toMonster(data.figure).isAllied) {
      <span class="allied"><span [ghs-label]="'game.allied'"></span>&nbsp;</span>
      }
      @if (data.entity && gameManager.isMonsterEntity(data.entity)) {
      <span class="standee-number"
        [ngClass]="gameManager.toMonsterEntity(data.entity).type + (bb ? ' bb-' + gameManager.toMonsterEntity(data.entity).number : '') ">#{{gameManager.toMonsterEntity(data.entity).number}}</span>
      }
    </div>
    }

    @if (data.entity && gameManager.isCharacter(data.figure) && gameManager.isSummon(data.entity)) {
    <small>
      <img class="icon" [src]="gameManager.toCharacter(data.figure).iconUrl" />
      @if (gameManager.toCharacter(data.figure).title) {
      <span>{{gameManager.toCharacter(data.figure).title}}</span>
      }
      @if (gameManager.toCharacter(data.figure).title) {
      <span>&nbsp;(<span [ghs-label]="'data.character.' + data.figure.edition + '.'+ data.figure.name"></span>)</span>
      }
      @if (!gameManager.toCharacter(data.figure).title) {
      <span [ghs-label]="'data.character.' + data.figure.edition + '.'+ data.figure.name"></span>
      }
    </small>
    @if (gameManager.toSummon(data.entity).title) {
    <span>{{gameManager.toSummon(data.entity).title}}&nbsp;</span>
    }
    @if (gameManager.toSummon(data.entity).name) {
    <span>@if (gameManager.toSummon(data.entity).title) {
      <span>(</span>
      }
      <span [ghs-label]="'data.summon.' + gameManager.toSummon(data.entity).name"></span>
      @if (gameManager.toSummon(data.entity).title) {
      <span>)</span>
      }</span>
    }
    @if (!gameManager.toSummon(data.entity).name) {
    <span><span [ghs-label]="'game.summon'"></span></span>
    }
    <span class="summon-icon" [ngClass]="{'fh': gameManager.toSummon(data.entity).color == SummonColor.fh}">
      @if (gameManager.toSummon(data.entity).color != SummonColor.fh) {
      <img src="./assets/images/summons/{{gameManager.toSummon(data.entity).color}}.png">
      }
      <span class="summon-number">{{gameManager.toSummon(data.entity).number}}</span>
    </span>
    }
  </div>

  @if (!levelDialog && (!gameManager.isCharacter(data.figure) || !gameManager.toCharacter(data.figure).absent)) {
  <div class="status-container">
    <div class="entity-container">
      @for (actionHint of actionHints | trackUUID; track actionHint._trackUUID) {
      <div class="action-hint">
        <ghs-action [action]="actionHint" [highlight]="settingsManager.settings.statAnimations"></ghs-action>
      </div>
      }
      @if (data.entity && EntityValueFunction(data.entity.maxHealth) > 0 && (!gameManager.isMonster(data.figure) ||
      !gameManager.toMonster(data.figure).immortal)) {
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeHealth(-1)" [soundboard]="'punch.mp3'" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'game.health'" [ghs-label-attribute]="'title'">
        <span class="badge badge-left">{{data.entity.health + health | ghsMinZero}}</span>
        <img src="./assets/images/status/health.svg" />
        <span class="badge badge-right health-count" [value-sign]="health" [hideEmpty]="true"></span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : (data.entity.health + health) == (Math.max(EntityValueFunction(data.entity.maxHealth), specialTags.includes('unbridled-power') ? 26 : 0) + maxHp)}"
          tabclick (singleClick)="changeHealth(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      @if (gameManager.isCharacter(data.entity) && !bb) {
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : gameManager.toCharacter(data.entity).experience + experience == 0}" tabclick
          (singleClick)="changeExperience(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'game.experience'" [ghs-label-attribute]="'title'">
        <span class="badge badge-left">{{gameManager.toCharacter(data.entity).experience + experience}}</span>
        <img src="./assets/images/status/experience.svg" />
        <span class="badge badge-right" [value-sign]="experience" [hideEmpty]="true"></span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeExperience(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      @if ((!settingsManager.settings.lootDeck || !settingsManager.settings.alwaysLootDeck && !gameManager.fhRules()) &&
      !settingsManager.settings.hideCharacterLoot) {
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : gameManager.toCharacter(data.entity).loot + loot == 0}" tabclick
          (singleClick)="changeLoot(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'game.loot'" [ghs-label-attribute]="'title'">
        <span class="badge badge-left">{{gameManager.toCharacter(data.entity).loot + loot}}</span>
        <img src="./assets/images/status/loot.svg" />
        <span class="badge badge-right" [value-sign]="loot" [hideEmpty]="true"></span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeLoot(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : gameManager.toCharacter(data.entity).token + characterToken == 0}" tabclick
          (singleClick)="changeCharacterToken(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item character-token" [ghs-label]="'character.token'" [ghs-label-attribute]="'title'">
        <span class="badge badge-left">{{gameManager.toCharacter(data.entity).token + characterToken}}</span>
        <span [ghs-label]="'%data.characterToken.' + gameManager.toCharacter(data.entity).name + '%'"></span>
        <span class="badge badge-right" [value-sign]="characterToken" [hideEmpty]="true"></span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeCharacterToken(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      @for (token of gameManager.toCharacter(data.entity).tokens; track token; let i = $index) {
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : gameManager.toCharacter(data.entity).tokenValues[i] + characterTokenValues[i] == 0}"
          tabclick (singleClick)="changeCharacterToken(-1, i)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item character-token"
        [ghs-label]="'data.character.' + gameManager.toCharacter(data.entity).edition + '.' + gameManager.toCharacter(data.entity).name + '.tokens.' + token"
        [ghs-label-attribute]="'title'">
        <span class="badge badge-left">{{gameManager.toCharacter(data.entity).tokenValues[i] +
          characterTokenValues[i]}}</span>
        <span
          [ghs-label]="'%data.characterToken.' + gameManager.toCharacter(data.entity).name + '.' + token + '%'"></span>
        <span class="badge badge-right" [value-sign]="characterTokenValues[i]" [hideEmpty]="true"></span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeCharacterToken(1, i)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
      }
      }
      @if ((gameManager.isCharacter(data.figure) && settingsManager.settings.characterSheet &&
      settingsManager.settings.characterAttackModifierDeck || gameManager.isMonster(data.figure)) && (!data.entity ||
      EntityValueFunction(data.entity.maxHealth) > 0 && (!gameManager.isMonster(data.figure) ||
      !gameManager.toMonster(data.figure).immortal) && !bb) || gameManager.isObjectiveContainer(data.figure) &&
      gameManager.toObjectiveContainer(data.figure).escort && gameManager.toObjectiveContainer(data.figure).amDeck) {
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : countUpcomingAttackModifier(AttackModifierType.bless) + bless == 0 || isImmune(ConditionName.bless) || entityImmunities.includes(ConditionName.bless)}"
          tabclick (singleClick)="changeBless(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item">
        <span class="badge badge-left bless-count">{{countUpcomingAttackModifier(AttackModifierType.bless) +
          bless}}</span>
        <span class="condition" [ghs-tooltip]="'game.condition.bless.hint'" [originX]="'center'" [overlayX]="'center'"
          [originY]="'top'" [overlayY]="'bottom'"
          [ngClass]="{'immunity disabled' : isImmune(ConditionName.bless) || entityImmunities.includes(ConditionName.bless)}">
          <img src="./assets/images/status/bless.svg" />
        </span>
        <span class="badge badge-right" [value-sign]="bless" [hideEmpty]="true"></span>
        @if (gameManager.attackModifierManager.countUpcomingBlesses() + bless > 10) {
        <span class="badge badge-center badge-warning">
          <img src="./assets/images/warning.svg" />
        </span>
        }
      </span>
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : gameManager.attackModifierManager.countUpcomingBlesses() + bless >= 10 || isImmune(ConditionName.bless) || entityImmunities.includes(ConditionName.bless)}"
          tabclick (singleClick)="changeBless(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : countUpcomingAttackModifier(AttackModifierType.curse) + curse == 0 || isImmune(ConditionName.curse) || entityImmunities.includes(ConditionName.curse)}"
          tabclick (singleClick)="changeCurse(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item">
        <span class="badge badge-left curse-count">{{countUpcomingAttackModifier(AttackModifierType.curse) +
          curse}}</span>
        <span class="condition" [ghs-tooltip]="'game.condition.curse.hint'" [originX]="'center'" [overlayX]="'center'"
          [originY]="'top'" [overlayY]="'bottom'"
          [ngClass]="{'immunity disabled' : isImmune(ConditionName.curse) || entityImmunities.includes(ConditionName.curse)}">
          <img src="./assets/images/status/curse.svg" />
        </span>
        <span class="badge badge-right" [value-sign]="curse" [hideEmpty]="true"></span>
        @if (gameManager.attackModifierManager.countUpcomingCurses(gameManager.isMonster(data.figure) &&
        !gameManager.toMonster(data.figure).isAlly && !gameManager.toMonster(data.figure).isAllied) + curse > 10) {
        <span class="badge badge-center badge-warning">
          <img src="./assets/images/warning.svg" />
        </span>
        }
      </span>
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : gameManager.attackModifierManager.countUpcomingCurses(gameManager.isMonster(data.figure) && !gameManager.toMonster(data.figure).isAlly && !gameManager.toMonster(data.figure).isAllied || gameManager.isObjectiveContainer(data.figure) && gameManager.toObjectiveContainer(data.figure).amDeck == 'M') + curse >= 10 || isImmune(ConditionName.curse) || entityImmunities.includes(ConditionName.curse)}"
          tabclick (singleClick)="changeCurse(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      @if (hasCondition(ConditionName.empower)) {
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : countUpcomingAttackModifier(AttackModifierType.empower) + empower == 0  || isImmune(ConditionName.empower) || entityImmunities.includes(ConditionName.empower)}"
          tabclick (singleClick)="changeEmpower(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item">
        <span class="badge badge-left empower-count">{{countUpcomingAttackModifier(AttackModifierType.empower) +
          empower}}</span>
        <span class="condition" [ghs-tooltip]="'game.condition.empower.hint'" [originX]="'center'" [overlayX]="'center'"
          [originY]="'top'" [overlayY]="'bottom'"
          [ngClass]="{'immunity disabled' : isImmune(ConditionName.empower) || entityImmunities.includes(ConditionName.empower)}">
          <img src="./assets/images/status/empower.svg" />
        </span>
        <span class="badge badge-right" [value-sign]="empower" [hideEmpty]="true"></span>
        @if (countEmpower() < 0) { <span class="badge badge-center badge-warning">
          <img src="./assets/images/warning.svg" />
      </span>
      }
      @if (!!empowerChar) {
      <span class="badge badge-character-icon">
        <img [src]="empowerChar.iconUrl" />
      </span>
      }
      </span>
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : empowerChar && empower >= countEmpower() || isImmune(ConditionName.empower) || entityImmunities.includes(ConditionName.empower)}"
          tabclick (singleClick)="changeEmpower(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
      @if (hasCondition(ConditionName.enfeeble)) {
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' : countUpcomingAttackModifier(AttackModifierType.enfeeble) + enfeeble == 0 || isImmune(ConditionName.enfeeble) || entityImmunities.includes(ConditionName.enfeeble)}"
          tabclick (singleClick)="changeEnfeeble(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item">
        <span class="badge badge-left enfeeble-count">{{countUpcomingAttackModifier(AttackModifierType.enfeeble) +
          enfeeble}}</span>
        <span class="condition" [ghs-tooltip]="'game.condition.enfeeble.hint'" [originX]="'center'"
          [overlayX]="'center'" [originY]="'top'" [overlayY]="'bottom'"
          [ngClass]="{'immunity disabled' : isImmune(ConditionName.enfeeble) || entityImmunities.includes(ConditionName.enfeeble)}">
          <img src="./assets/images/status/enfeeble.svg" />
        </span>
        <span class="badge badge-right" [value-sign]="enfeeble" [hideEmpty]="true"></span>
        @if (countEnfeeble() < 0) { <span class="badge badge-center badge-warning">
          <img src="./assets/images/warning.svg" />
      </span>
      }
      @if (!!enfeebleChar) {
      <span class="badge badge-character-icon">
        <img [src]="enfeebleChar.iconUrl" />
      </span>
      }
      </span>
      <span class="item">
        <ghs-pointer-input class="button"
          [ngClass]="{'disabled' :  enfeebleChar && enfeeble >= countEnfeeble() || isImmune(ConditionName.enfeeble) || entityImmunities.includes(ConditionName.enfeeble)}"
          tabclick (singleClick)="changeEnfeeble(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
      }
      @if (data.entity && EntityValueFunction(data.entity.maxHealth) == 0 && objectiveData && objectiveData.trackDamage)
      {
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeHealth(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'game.health'" [ghs-label-attribute]="'title'">
        <span class="badge badge-left">{{data.entity.health + health | ghsMinZero}}</span>
        <img class="damage" src="./assets/images/action/damage.svg" />
        <span class="badge badge-right health-count" [value-sign]="health" [hideEmpty]="true" [invert]="true"></span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeHealth(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
      @if (data.entity && gameManager.isObjectiveEntity(data.entity)) {
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeId(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/left.svg">
        </ghs-pointer-input>
      </span>
      <span class="item">
        <span class="objective-marker">{{(gameManager.toObjectiveEntity(data.entity).number + id)}}</span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeId(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/right.svg">
        </ghs-pointer-input>
      </span>
      }
      @if (data.figure && gameManager.isObjectiveContainer(data.figure)) {
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeMarker(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/left.svg">
        </ghs-pointer-input>
      </span>
      @if (!data.entity || !gameManager.isObjectiveEntity(data.entity)) {
      <span class="item">
        <span class="map-marker"
          [ngClass]="{'empty' : !OBJECTIV_MARKERS[(marker +
          OBJECTIV_MARKERS.indexOf(gameManager.toObjectiveContainer(data.figure).marker)) % OBJECTIV_MARKERS.length]}">{{OBJECTIV_MARKERS[(marker
          +
          OBJECTIV_MARKERS.indexOf(gameManager.toObjectiveContainer(data.figure).marker)) %
          OBJECTIV_MARKERS.length]}}</span>
      </span>
      }
      @if (data.entity && gameManager.isObjectiveEntity(data.entity)) {
      <span class="item">
        <span class="map-marker"
          [ngClass]="{'empty' : !OBJECTIV_MARKERS[(marker +
          OBJECTIV_MARKERS.indexOf(gameManager.toObjectiveEntity(data.entity).marker)) % OBJECTIV_MARKERS.length]}">{{OBJECTIV_MARKERS[(marker
          +
          OBJECTIV_MARKERS.indexOf(gameManager.toObjectiveEntity(data.entity).marker)) %
          OBJECTIV_MARKERS.length]}}</span>
      </span>
      }
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeMarker(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/right.svg">
        </ghs-pointer-input>
      </span>
      }
      @if (data.entity && gameManager.isSummon(data.entity)) {
      <div class="summon-stats-container">
        <span class="stat" tabclick (click)="openLevelDialog()">
          <img class="ghs-svg" src="./assets/images/action/move.svg" />
          <span [value-calc]="gameManager.toSummon(data.entity).movement" [empty]="true">></span>
        </span>
        <span class="stat" tabclick (click)="openLevelDialog()">
          <img class="ghs-svg" src="./assets/images/action/attack.svg" />
          @if (gameManager.toSummon(data.entity).attack != 0) {
          <span [ghs-label]="'' + gameManager.toSummon(data.entity).attack"></span>
          }
          @if (gameManager.toSummon(data.entity).attack == 0) {
          <span>-</span>
          }
        </span>
        <span class="stat" tabclick (click)="openLevelDialog()">
          <img class="ghs-svg" src="./assets/images/action/range.svg" />
          <span [value-calc]="gameManager.toSummon(data.entity).range" [empty]="true">></span>
        </span>
        @if (gameManager.toSummon(data.entity).action) {
        <span class="action">
          <ghs-action [action]="gameManager.toSummon(data.entity).action"></ghs-action>
        </span>
        }
        @if (gameManager.toSummon(data.entity).additionalAction) {
        <span class="action">
          <ghs-action [action]="gameManager.toSummon(data.entity).additionalAction"></ghs-action>
        </span>
        }
      </div>
      }
      @if (data.entity && gameManager.isCharacter(data.entity)) {
      <span class="item" [ghs-label]="'game.exhausted'" [ghs-label-attribute]="'title'"
        [ngClass]="{'active' : gameManager.toCharacter(data.entity).exhausted}">
        <a class="exhausted" tabclick (click)="toggleExhausted()">
          <img class="ghs-svg" src="./assets/images/status/exhausted.svg" />
        </a>
      </span>
      }
      @if (data.entity && gameManager.isObjectiveEntity(data.entity)) {
      <span class="item" [ghs-label]="'game.dead'" [ghs-label-attribute]="'title'">
        <a class="button" tabclick [soundboard]="'bell.mp3'" (click)="toggleDead()">
          <img src="./assets/images/status/dead.svg" />
        </a>
      </span>
      }
      @if (data.entity && gameManager.isCharacter(data.entity)) {
      <span class="item" [ghs-label]="'game.level'" [ghs-label-attribute]="'title'">
        <a class="button level-button" tabclick (click)="openLevelDialog()">
          {{data.figure.level}} <img src="./assets/images/status/level.svg" />
        </a>
      </span>
      }
      @if (data.entity && gameManager.isSummon(data.entity)) {
      <span class="item" [ghs-label]="'game.dead'" [ghs-label-attribute]="'title'">
        <a class="button" tabclick [soundboard]="'bell.mp3'" (click)="toggleDead()">
          <img src="./assets/images/status/dead.svg" />
        </a>
      </span>
      <span class="item" [ghs-label]="'game.level'" [ghs-label-attribute]="'title'">
        <a class="button level-button" tabclick (click)="openLevelDialog()">
          {{data.figure.level}} <img src="./assets/images/status/level.svg" />
        </a>
      </span>
      <span class="item">
        <a class="summon"
          [ngClass]="{'active' : gameManager.toSummon(data.entity).state == SummonState.true, 'new' : gameManager.toSummon(data.entity).state == SummonState.new, 'fh':  gameManager.toSummon(data.entity).color == SummonColor.fh }"
          tabclick (click)="toggleSummonStatus()">
          @if (gameManager.toSummon(data.entity).color != SummonColor.fh) {
          <img src="./assets/images/summons/{{gameManager.toSummon(data.entity).color}}.png">
          }
          @if (gameManager.toSummon(data.entity).color == SummonColor.fh) {
          <span class="summon-number">
            {{gameManager.toSummon(data.entity).number }}
          </span>
          }
        </a>
      </span>
      }
      @if (data.entity && gameManager.isMonsterEntity(data.entity)) {
      <span class="item" [ghs-label]="'game.dead'" [ghs-label-attribute]="'title'">
        <a class="button" tabclick [soundboard]="'bell.mp3'" (click)="toggleDead()">
          <img src="./assets/images/status/dead.svg" />
        </a>
      </span>
      @if (EntityValueFunction(data.entity.maxHealth) > 0) {
      <span class="item max-health-container">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeMaxHealth(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
        <img src="./assets/images/status/health.svg" [ghs-label]="'game.maxHealth'" [ghs-label-attribute]="'title'" />
        <span class="badge badge-right max-health">{{(EntityValueFunction(data.entity.maxHealth) + maxHp <
            EntityValueFunction(data.entity.maxHealth) || data.entity.health==(+data.entity.maxHealth) ?
            EntityValueFunction(data.entity.maxHealth) + maxHp :
            data.entity.health)}}/{{EntityValueFunction(data.entity.maxHealth) + maxHp}}</span>
            <ghs-pointer-input class="button" tabclick (singleClick)="changeMaxHealth(1)" [repeat]="true">
              <img class="ghs-svg" src="./assets/images/plus.svg">
            </ghs-pointer-input>
        </span>
        }
        }
        @if (catching) {
        <span class="item" [ghs-label]="'data.buildings.stables.pets.catch'" [ghs-label-attribute]="'title'">
          <ghs-pointer-input class="button" tabclick (singleClick)="dead(true)" (doubleClick)="dead(true, true)"
            [ngClass]="{'disabled soft' : catchingDisabled}">
            <img class="ghs-svg" src="./assets/images/fh/catching.svg" />
          </ghs-pointer-input>
        </span>
        }
        @if (!bb) {
        <div class="marker-container">
          @if (data.entity && EntityValueFunction(data.entity.maxHealth) > 0 && (!gameManager.isMonster(data.figure) ||
          !gameManager.toMonster(data.figure).immortal) && gameManager.isMonsterEntity(data.entity)) {
          <a class="summon"
            [ngClass]="{'active' : gameManager.toMonsterEntity(data.entity).summon == SummonState.true, 'new' : gameManager.toMonsterEntity(data.entity).summon == SummonState.new }"
            tabclick (click)="toggleSummon()">
            <img src="./assets/images/summons/{{gameManager.toMonster(data.figure).summonColor}}.png">
          </a>
          }
          @for (marker of markers(); track marker) {
          <span>
            <a class="item" [ngClass]="{'active' : hasMarker(marker)}" (click)="toggleMarker(marker)">
              <span class="condition marker">
                <img [src]="gameManager.characterManager.characterIcon(marker)" />
              </span>
            </a>
          </span>
          }
        </div>
        }
    </div>
    @if (data.entity && EntityValueFunction(data.entity.maxHealth) > 0 && (!gameManager.isMonster(data.figure) ||
    !gameManager.toMonster(data.figure).immortal)) {
    <ghs-conditions [entityConditions]="entityConditions" [immunities]="entityImmunities" [entity]="data.entity"
      [figure]="data.figure" [type]="conditionType" [empower]="hasCondition(ConditionName.empower)"
      [enfeeble]="hasCondition(ConditionName.enfeeble)"></ghs-conditions>
    }
    @if (data.entity && (settingsManager.settings.characterShieldRetaliate && (gameManager.isCharacter(data.entity) ||
    gameManager.isObjectiveContainer(data.figure) && gameManager.toObjectiveContainer(data.figure).escort &&
    gameManager.isObjectiveEntity(data.entity)) || settingsManager.settings.standeeShieldRetaliate &&
    (gameManager.isMonsterEntity(data.entity) || gameManager.isSummon(data.entity)))) {
    <div class="entity-container">
      <span class="shield-overlay">
        <span class="text-white" [ghs-label]="'%game.card.round%'"></span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeShield(-1)"
          [ngClass]="{'disabled' : !entityShield.value}">
          <img class=" ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item">
        <ghs-action [action]="entityShield" [style]="'fh'"></ghs-action>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeShield(1)">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      @for (realiate of entityRetaliate | trackUUID; track realiate._trackUUID; let i = $index) {
      <span class="item column">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeRetaliate(i,-1,0)"
          [ngClass]="{'disabled' : !realiate.value}">
          <img class=" ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
        <ghs-pointer-input class="button small" tabclick (singleClick)="changeRetaliate(i,0,-1)"
          [ngClass]="{'disabled' : EntityValueFunction(entityRetaliateRange[i].value) <= 1}">
          <img class=" ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item column">
        <ghs-action [action]="realiate" [style]="'fh'"></ghs-action>
        <ghs-action [action]="entityRetaliateRange[i]" [style]="'fh'"></ghs-action>
        @if (i == entityRetaliate.length -1 && realiate.value) {
        <ghs-pointer-input class="button add-retaliate" tabclick
          (singleClick)="changeRetaliate(entityRetaliate.length,1,0)">
          <img class="ghs-svg" src="./assets/images/select-arrow.svg">
        </ghs-pointer-input>
        }
      </span>
      <span class="item column">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeRetaliate(i,1, 0)">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
        <ghs-pointer-input class="button small" tabclick (singleClick)="changeRetaliate(i,0, 1)">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
      <div class="separator"></div>
      <span class="shield-overlay">
        <span class="text-white" [ghs-label]="'%game.card.persistent%'"></span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeShieldPersistent(-1)"
          [ngClass]="{'disabled' : !entityShieldPersistent.value}">
          <img class=" ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item">
        <ghs-action [action]="entityShieldPersistent" [style]="'fh'"></ghs-action>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeShieldPersistent(1)">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      @for (realiatePermanent of entityRetaliatePersistent | trackUUID; track realiatePermanent._trackUUID; let i =
      $index) {
      <span class="item column">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeRetaliatePersistent(i,-1,0)"
          [ngClass]="{'disabled' : !realiatePermanent.value}">
          <img class=" ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
        <ghs-pointer-input class="button small" tabclick (singleClick)="changeRetaliatePersistent(i,0,-1)"
          [ngClass]="{'disabled' : EntityValueFunction(entityRetaliateRangePersistent[i].value) <= 1}">
          <img class=" ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item column">
        <ghs-action [action]="realiatePermanent" [style]="'fh'"></ghs-action>
        <ghs-action [action]="entityRetaliateRangePersistent[i]" [style]="'fh'"></ghs-action>
        @if (i == entityRetaliatePersistent.length -1 && realiatePermanent.value) {
        <ghs-pointer-input class="button add-retaliate" tabclick
          (singleClick)="changeRetaliatePersistent(entityRetaliatePersistent.length,1,0)">
          <img class="ghs-svg" src="./assets/images/select-arrow.svg">
        </ghs-pointer-input>
        }
      </span>
      <span class="item column">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeRetaliatePersistent(i,1, 0)">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
        <ghs-pointer-input class="button small" tabclick (singleClick)="changeRetaliatePersistent(i,0, 1)">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
    </div>
    }
  </div>
  }


  @if (!levelDialog && (identities.length || specialActions.length)) {
  <hr class="character-special" />
  }

  @if (!levelDialog && data.entity && gameManager.isCharacter(data.entity) && identities.length > 1) {
  <div class="identities-container">
    @for (identity of [] | ghsRange:identities.length; track identity) {
    <a class="item" (click)="setIdentity(identity)"
      [ghs-tooltip]="'data.character.' + gameManager.toCharacter(data.entity).edition + '.' + gameManager.toCharacter(data.entity).name + '.' +  identities[identity]"
      [ngClass]="{'deactivated': gameManager.toCharacter(data.entity).identity == identity}">
      <img
        [src]="gameManager.characterManager.characterIdentityIcon(gameManager.toCharacter(data.entity).name, identity)" />
    </a>
    }
  </div>
  }

  @if (!levelDialog && data.entity && specialActions.length > 0) {
  <div class="special-actions">
    @for (specialAction of specialActions | trackUUID; track
    specialAction._trackUUID) {
    @if ((!specialAction.level || specialAction.level <= data.figure.level) && (!specialAction.perk ||
      gameManager.isCharacter(data.entity) &&
      gameManager.toCharacter(data.figure).progress.perks[specialAction.perk-1]==gameManager.toCharacter(data.figure).perks[specialAction.perk-1].count)
      && (gameManager.isCharacter(data.entity) && !specialAction.summon || gameManager.isSummon(data.entity) &&
      specialAction.summon)) { <div class="hint-container">
      <img src="./assets/images/hint.svg" class="hint-trigger ghs-svg"
        [ghs-tooltip]="'data.character.' + data.figure.edition + '.' + data.figure.name + '.' + specialAction.name + '.hint'"
        [originX]="'center'" [overlayX]="'center'" [originY]="'top'" [overlayY]="'bottom'">
      <span class="special-action text-white" [ngClass]="{'active-tag' : specialTags.includes(specialAction.name)}"
        tabclick (click)="applySpecialAction(specialAction)">
        <span
          [ghs-label]="'data.character.' + data.figure.edition + '.' + data.figure.name + '.' + specialAction.name"></span>
      </span>
  </div>
  }
  }
</div>
}

@if (gameManager.isObjectiveContainer(data.figure)) {
<div class="objective-container">
  <input class="title" #objectiveTitle [value]="gameManager.toObjectiveContainer(data.figure).title || ''" />
  @if (showMaxHealth() && data.entity && gameManager.isObjectiveEntity(data.entity)) {
  <a class="button" tabclick (click)="changeMaxHealth(-1)">
    <img class="ghs-svg" src="./assets/images/minus.svg">
  </a>
  <span class="item">
    <img src="./assets/images/status/health.svg" />
    <span
      class="badge badge-right max-health">{{(EntityValueFunction(gameManager.toObjectiveContainer(data.figure).health)
      + maxHp < EntityValueFunction(gameManager.toObjectiveContainer(data.figure).health) ||
        data.entity.health==EntityValueFunction(gameManager.toObjectiveContainer(data.figure).health) ?
        EntityValueFunction(gameManager.toObjectiveContainer(data.figure).health) + maxHp :
        data.entity.health)}}/{{EntityValueFunction(gameManager.toObjectiveContainer(data.figure).health) +
        maxHp}}</span>
    </span>
    <a class="button" tabclick (click)="changeMaxHealth(1)">
      <img class="ghs-svg" src="./assets/images/plus.svg">
    </a>
    }
</div>
<div class="decks">
  @for (deck of amDecks; track deck) {
  <span class="deck" [ngClass]="{'active': gameManager.toObjectiveContainer(data.figure).amDeck == deck}"
    (click)="toggleAMDeck(deck)">
    @if (deck == 'M') {
    m
    }
    @if (deck == 'A') {
    A
    }
    @if (deck != 'M' && deck != 'A') {
    <img [src]="gameManager.characterManager.characterIcon(deck)">
    }
  </span>
  }
  @if (gameManager.toObjectiveContainer(data.figure).amDeck &&
  amDecks.indexOf(gameManager.toObjectiveContainer(data.figure).amDeck ||'') == -1) {
  <span class="deck active warning" (click)="toggleAMDeck(gameManager.toObjectiveContainer(data.figure).amDeck || '')">
    <img [src]="gameManager.characterManager.characterIcon(gameManager.toObjectiveContainer(data.figure).amDeck || '')">
  </span>
  }
</div>
}

@if (levelDialog) {
<div class="level-dialog">
  @if (data.entity && gameManager.isCharacter(data.entity)) {
  <div class="level-container" [ngClass]="{'bb' : bb}">
    <a (click)="levelDialog = false" class="item"><img src="./assets/images/status/level.svg" /></a>
    @for (level of [] | ghsRange:(bb ? 5 : 9); track level) {
    <span class="item"><a class="level" [ngClass]="{'active' : level + 1 == data.entity.level}" tabclick
        (click)="setLevel(level + 1)">{{level
        +1}}</a></span>
    }
  </div>
  <div class="char-container">
    @if (titles.length == 0 || !identities.length) {
    <img [src]="gameManager.characterManager.characterIcon(gameManager.toCharacter(data.entity).name)">
    <input class="title" #charactertitle type="text" [value]="gameManager.toCharacter(data.entity).title">
    }
    @if (titles.length > 0 && identities.length) {
    <div class="titles-container">
      @for (i of [] | ghsRange:identities.length; track i) {
      <div class="title-container">
        <img [src]="gameManager.characterManager.characterIdentityIcon(gameManager.toCharacter(data.entity).name,i)">
        <input class="title" type="text" [value]="titles[i]" (change)="setTitle($event, i)">
      </div>
      }
    </div>
    }
    <a class="button" tabclick (click)="changeMaxHealth(-1)">
      <img class="ghs-svg" src="./assets/images/minus.svg">
    </a>
    <span class="item" [ghs-label]="'game.maxHealth'" [ghs-label-attribute]="'title'">
      <img src="./assets/images/status/health.svg" />
      <span class="badge badge-right max-health">{{(EntityValueFunction(data.entity.maxHealth) + maxHp <
          EntityValueFunction(data.entity.maxHealth) || data.entity.health==EntityValueFunction(data.entity.maxHealth) ?
          EntityValueFunction(data.entity.maxHealth) + maxHp :
          data.entity.health)}}/{{EntityValueFunction(data.entity.maxHealth) + maxHp}}</span>
      </span>
      <a class="button" tabclick (click)="changeMaxHealth(1)">
        <img class="ghs-svg" src="./assets/images/plus.svg">
      </a>
  </div>
  }
  @if (data.entity && gameManager.isSummon(data.entity)) {
  <input class="title" #summonTitle />
  <div class="summon-container">
    <a class="button" tabclick (click)="changeMaxHealth(-1)"
      [ngClass]="{'disabled' : EntityValueFunction(data.entity.maxHealth) + maxHp == 0}">
      <img class="ghs-svg" src="./assets/images/minus.svg">
    </a>
    <span class="item">
      <img src="./assets/images/status/health.svg" />
      <span class="badge badge-right max-health">{{(EntityValueFunction(data.entity.maxHealth) + maxHp <
          EntityValueFunction(data.entity.maxHealth) || data.entity.health==EntityValueFunction(data.entity.maxHealth) ?
          EntityValueFunction(data.entity.maxHealth) + maxHp :
          data.entity.health)}}/{{EntityValueFunction(data.entity.maxHealth) + maxHp}}</span>
      </span>
      <a class="button" tabclick (click)="changeMaxHealth(1)">
        <img class="ghs-svg" src="./assets/images/plus.svg">
      </a>
      <a class="button" tabclick (click)="changeMovement(-1)"
        [ngClass]="{'disabled' : gameManager.toSummon(data.entity).movement + movement == 0}">
        <img class="ghs-svg" src="./assets/images/minus.svg">
      </a>
      <span class="item">
        <img class="ghs-svg" src="./assets/images/action/move.svg" />
        <span class="badge badge-right" [value-calc]="gameManager.toSummon(data.entity).movement + movement"
          [empty]="true">></span>
      </span>
      <a class="button" tabclick (click)="changeMovement(1)">
        <img class="ghs-svg" src="./assets/images/plus.svg">
      </a>
      <a class="button" tabclick (click)="changeAttack(-1)"
        [ngClass]="{'disabled' : gameManager.toSummon(data.entity).attack == 'X' || +gameManager.toSummon(data.entity).attack + attack == 0}">
        <img class="ghs-svg" src="./assets/images/minus.svg">
      </a>
      <span class="item">
        <img class="ghs-svg" src="./assets/images/action/attack.svg" />
        @if (gameManager.toSummon(data.entity).attack != 'X') {
        <span class="badge badge-right" [value-calc]="+gameManager.toSummon(data.entity).attack + attack"
          [empty]="true"></span>
        }
        @if (gameManager.toSummon(data.entity).attack == 'X') {
        <span class="badge badge-right">X</span>
        }
      </span>
      <a class="button" tabclick (click)="changeAttack(1)"
        [ngClass]="{'disabled' : gameManager.toSummon(data.entity).attack == 'X'}">
        <img class="ghs-svg" src="./assets/images/plus.svg">
      </a>
      <a class="button" tabclick (click)="changeRange(-1)"
        [ngClass]="{'disabled' : gameManager.toSummon(data.entity).range + range == 0}">
        <img class="ghs-svg" src="./assets/images/minus.svg">
      </a>
      <span class="item">
        <img class="ghs-svg" src="./assets/images/action/range.svg" />
        <span class="badge badge-right" [value-calc]="gameManager.toSummon(data.entity).range + range"
          [empty]="true">></span>
      </span>
      <a class="button" tabclick (click)="changeRange(1)">
        <img class="ghs-svg" src="./assets/images/plus.svg">
      </a>
  </div>
  }
</div>
}
</div>